import VisaIcon from '../../../../assets/icons/common/payments/VisaIcon';
import MasterCardIcon from '../../../../assets/icons/common/payments/MasterCardIcon';
import AmexIcon from '../../../../assets/icons/common/payments/AmexIcon';
import DiscoverIcon from '../../../../assets/icons/common/payments/DiscoverIcon';
import DinersClub from '../../../../assets/icons/common/payments/DinersClub';

const paymentIcons = {
  visa: VisaIcon,
  mastercard: MasterCardIcon,
  amex: AmexIcon,
  'american express': AmexIcon,
  discover: DiscoverIcon,
  'diners club': DinersClub,
  diners_club: DinersClub,
};

export default paymentIcons;
